// src/App.js
import React, { useState } from "react";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import UploadForm from "./components/UploadForm";
import DiffView from "./components/DiffView";
import SuggestionsSidebar from "./components/SuggestionsSidebar";
import ExportButtons from "./components/ExportButtons";
import PreviewChanges from "./components/PreviewChanges";
import { Button, Box } from "@mui/material";

function App() {
  const [analysis, setAnalysis] = useState(null);
  const [accepted, setAccepted] = useState({});
  const [previewOpen, setPreviewOpen] = useState(false);

  const handleAnalysis = (analysisData) => {
    setAnalysis(analysisData);
    // Initialize all suggestions as accepted by default
    const initialAccepted = {};
    analysisData.suggestions.forEach((_, idx) => {
      initialAccepted[idx] = true;
    });
    setAccepted(initialAccepted);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Typography variant="h3" align="center" gutterBottom>
        AI-Powered ATS Resume Optimizer
      </Typography>
      {!analysis && <UploadForm onAnalysis={handleAnalysis} />}
      {analysis && (
        <>
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 3 }}>
            <ExportButtons analysis={analysis} accepted={accepted} />
            <Button
              variant="contained"
              color="primary"
              onClick={() => setPreviewOpen(true)}
            >
              Preview Changes
            </Button>
          </Box>
          <div
            style={{
              display: "flex",
              gap: 32,
              marginTop: 32,
              width: "100%",
            }}
          >
            <div style={{ flex: "60%" }}>
              <DiffView
                analysis={analysis}
                accepted={accepted}
                setAccepted={setAccepted}
              />
            </div>
            <div style={{ flex: "40%" }}>
              <SuggestionsSidebar analysis={analysis} accepted={accepted} />
            </div>
          </div>
          <PreviewChanges
            open={previewOpen}
            onClose={() => setPreviewOpen(false)}
            analysis={analysis}
            accepted={accepted}
          />
        </>
      )}
    </Container>
  );
}
export default App;